import { render } from "./Librairie.vue?vue&type=template&id=dd853634&ts=true"
import script from "./Librairie.vue?vue&type=script&lang=ts"
export * from "./Librairie.vue?vue&type=script&lang=ts"

import "./Librairie.vue?vue&type=style&index=0&id=dd853634&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__